import React from "react";

import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../Context/InshData";
import { uri } from "../../../help/Api";
import LoadingPage from "../../../services/LoadingPage";
import AddNotes from "./addNotes";
import NotesScreen from "./SelectNotes";
import { Dialog, DialogActions, DialogContent } from "@material-ui/core";
import { useStylesItemDilog } from "../../Invs/BackEnd/models/ItemDataDialog";
import { useStylesDPM } from "../../../St/comps/UseStyle";
const defaultAutos = {
    Branches: [],
};

export default function AddBillNaotes() {

    const tb = {
        wait: true,
        EmpItems: true,
        groups: true,
        billNotes: true,
        stor: { ...sto, branchi: sto.branchi },
        parms: {
            iempid: sto.empi,
            tname: "level",
            branch: sto.branchi,
            db_name: sto?.db_name,
        }
    };

    const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
        uri + "GetD",
        tb,
    );

    if (
        fetchAll || !AutoOptions.items || !AutoOptions.groups
    )
        return <LoadingPage />;

    return (
        // <NotesScreen
        <AddNotes
            {...{
                AutoOptions: AutoOptions?.items ? AutoOptions : defaultAutos,
                isDialog: false,
            }}
        />
    );
}

export function AddBillNaotesDialog({ openNotes, setOpenNotes }) {

    const classes = useStylesItemDilog();
    const clasPM = useStylesDPM();

    const tb = {
        wait: true,
        EmpItems: true,
        groups: true,
        billNotes: true,
        stor: { ...sto, branchi: sto.branchi },
        parms: {
            iempid: sto.empi,
            tname: "level",
            branch: sto.branchi,
            db_name: sto?.db_name,
        }
    };

    const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
        uri + "GetD",
        tb,
    );

    if (
        fetchAll || !AutoOptions.items || !AutoOptions.groups
    )
        return <LoadingPage />;

    return (
        <Dialog
            fullScreen
            className={clasPM.rootNTS}
            open={openNotes}
            lg={{ direction: "rtl", minHeight: 250, minHeight: 250 }}
            aria-labelledby="form-dialog-title"
        >
            <DialogContent className={classes.dialogContent}>
                <AddNotes
                    {...{
                        AutoOptions: AutoOptions?.items ? AutoOptions : defaultAutos,
                        isDialog: true,
                        setOpenNotes
                    }}
                />
            </DialogContent>
            {/* <DialogActions className={classes.dialogAction}>
                <Button onClick={() => getCloseDialog()}>إغلاق </Button>
            </DialogActions> */}
        </Dialog>

    );
}


export function SelectItemNotes({ infoNotes, setInfoNotes, AddNotesToItem }) {

    const classes = useStylesItemDilog();
    const clasPM = useStylesDPM();

    return (
        <Dialog
            fullScreen
            className={clasPM.rootNTS}
            open={infoNotes.open}
            lg={{ direction: "rtl", minHeight: 250, minHeight: 250 }}
            aria-labelledby="form-dialog-title"
        >
            <DialogContent className={classes.dialogContent}>
                <NotesScreen
                    {...{
                        isDialog: true,
                        infoNotes,
                        setInfoNotes,
                        AddNotesToItem
                    }}
                />
            </DialogContent>
        </Dialog>

    );
}

